(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.neya-section-heading, .neya-collection, .neya-product, .neya-story > div, .neya-how > div';
  const seen = new WeakSet();
  let observer;
  const reveal = element => {
    element.classList.remove('neya-reveal-pending');
    element.classList.add('neya-reveal-visible');
  };
  const initialise = root => {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    }
    root.querySelectorAll(selector).forEach((element, index) => {
      if (seen.has(element)) return;
      seen.add(element);
      const bounds = element.getBoundingClientRect();
      if (bounds.top < window.innerHeight) return;
      element.style.setProperty('--neya-reveal-delay', `${index % 4 * 65}ms`);
      element.classList.add('neya-reveal-pending');
      observer.observe(element);
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:block:select', event => {
    const element = event.target.closest(selector);
    if (element) reveal(element);
  });
  preference.addEventListener('change', event => {
    if (!event.matches) return;
    if (observer) observer.disconnect();
    document.querySelectorAll('.neya-reveal-pending').forEach(reveal);
  });
})();
